export default __webpack_public_path__ + "static/media/boardLow.min.af9b2794.png";